export default __webpack_public_path__ + "static/outline-nomination-1517ec7be819f37c5cddc51f09c67b48.svg";